import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Filter } from '../model/search-filters/filter';

@Injectable({
  providedIn: 'root',
})
export class FilterService {
  constructor(private httpClient: HttpClient) {}

  public getAllFilters(): Observable<Filter[]> {
    const url = `/upstream/gymfinder/internal/admin/v1/filter`;
    return this.httpClient.get<Filter[]>(url, { withCredentials: true });
  }

  public createFilter(filter: Filter): Observable<Filter> {
    const url = '/upstream/gymfinder/internal/admin/v1/filter';
    return this.httpClient.post<Filter>(url, filter, { withCredentials: true });
  }
  public updateFilter(filterId: string, filter: Filter): Observable<Filter> {
    const url = `/upstream/gymfinder/internal/admin/v1/filter/${filterId}`;
    return this.httpClient.put<Filter>(url, filter, { withCredentials: true });
  }
}
